import { FC, memo } from 'react'

import { ContactListWebPageResponseItem } from 'commons/types/contracts/api/bank/contactList'
import { TableDataQa } from 'commons/types/enums'
import { Layer, Table } from 'ui/components'
import { ButtonGroup } from 'ui/components/ButtonGroup'
import { Button } from 'ui/components/Buttons'
import { Link } from 'ui/components/Link'
import { Page } from 'ui/components/Page'

import { CONTACTS_PATH } from '../../../../constants'
import { ContactListPageProps } from './ContactListPageProps'
import { columns } from './columns'
import { Filter } from './components'

export const ContactListPage: FC<ContactListPageProps> = memo((props) => {
  const { webPageData, tableState, isFetching, filterForm, changePagination, DeleteConfirmation, startContactDelete } =
    props

  return (
    <Page
      title="Contacts"
      actions={
        <ButtonGroup margin="small">
          {webPageData?.enableAddNew && (
            <Link to={`${CONTACTS_PATH}/new`}>
              <Button face="tertiary">Add New</Button>
            </Link>
          )}
        </ButtonGroup>
      }
    >
      <DeleteConfirmation />
      <Layer rounded shadowed stretch>
        <Filter
          form={filterForm}
          expanded={tableState?.expanded}
          onToggle={tableState.onFilterToggle}
          typesFilterValues={webPageData?.types}
          relationshipsFilterValues={[
            ...(webPageData?.relationshipsTypes || []),
            ...(webPageData?.myRelationshipsList || [])
          ]}
        />
        <Table<ContactListWebPageResponseItem>
          dataQa={TableDataQa.BP_CONTACTS_LIST}
          columns={columns(startContactDelete)}
          dataSource={
            webPageData?.items.map((el) => ({
              item: el
            })) || []
          }
          loading={isFetching}
          pagination={{
            page: filterForm.config.value.page,
            size: filterForm.config.value.size,
            onChange: changePagination,
            total: webPageData?.totalCount || 0
          }}
        />
      </Layer>
    </Page>
  )
})
